module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/land-purchase/land-pur-purchase/lp-purchase-grid/lp-purchase-grid.component.css
// module id = ./src/app/landprocurement/land-purchase/land-pur-purchase/lp-purchase-grid/lp-purchase-grid.component.css
// module chunks = main